//import * as firebase from 'firebase'
import firebase from 'firebase/compat/app'
import 'firebase/compat/functions';
import 'firebase/firestore'
import { snapshotToArray } from '../../utils'
import { saveError } from './error'
import { getCurrentUser } from './user'
import moment from 'moment'

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL

//<, <=, ==, >=, >, array-contains, in, array-contains-any}
// .where('orderState', 'in', ['En proceso', 'Entregado'])


export let getOrdersRealTimeUnsubscribe = () => { }
export let getOrdersRealTimeWithDateUnsubscribe = () => { }

export const getOrdersRealTime = (setState = () => { }, orderStates = ['En cocina', 'Demorado']) =>
  firebase.app().firestore().collection('orders')
    .where('orderState', 'in', orderStates)
    .orderBy('date', 'asc')
    .onSnapshot(querySnapshot => setState(snapshotToArray(querySnapshot.docs)))


export const getOrdersDeliveryRealTime = (setState = () => { }, orderStates = ['En reparto'], delivery = '') => {
  firebase.app().firestore().collection('orders')
    .where('orderState', 'in', orderStates)
    .where('delivery', '==', delivery)
    .onSnapshot(querySnapshot => setState(snapshotToArray(querySnapshot.docs)))
}

export const getOrdersBetweenDatesRealTime = (setState = () => { }, orderStates = ['En cocina', 'Demorado'], startDate = new Date(), endDate = new Date()) => {

  //console.log('startDate', startDate)
  //console.log('endDate', endDate)
  return firebase.app().firestore().collection('orders')
    .where('orderState', 'in', orderStates)
    .where("date", ">=", startDate)
    .where("date", "<=", endDate)
    .orderBy('date', 'asc')
    .onSnapshot(querySnapshot => {
      //console.log('querySnapshot.docs: ', querySnapshot.docs)
      setState({ orders: snapshotToArray(querySnapshot.docs) })
    })
}

export const getOrderByIdRealTime = (id, setState = () => { }) =>
  firebase.app().firestore().collection('orders').doc(id)
    .onSnapshot(doc => setState(doc.data()))

export const getOrdersByClientIdRealTime = ({ clientId, orderStates = [], limit = 50, setState = () => { } }) =>
  firebase.app().firestore().collection('orders')
    .where("clientId", "==", clientId)
    .where('orderState', 'in', orderStates)
    .orderBy('date', 'desc')
    .limit(limit)
    .onSnapshot(querySnapshot => {
      //console.log('getOrdersByClientIdRealTime querySnapshot.docs: ', querySnapshot.docs)
      setState(snapshotToArray(querySnapshot.docs))
    })

export const lastOrderByClient = (clientId, orderStates = [], limit = 10) => new Promise((resolve, reject) => {
  firebase.app().firestore().collection('orders')
    .where("clientId", "==", clientId)
    .where('orderState', 'in', orderStates)
    .orderBy('date', 'desc')
    .limit(limit)
    .get()
    .then(querySnapshot => resolve(snapshotToArray(querySnapshot.docs)))
    .catch(reject)
})



export const getOrdersWithDate = (startDate = new Date(), endDate = new Date()) =>
  new Promise((resolve, reject) => {
    firebase.app().firestore().collection('orders')
      .where("date", ">=", startDate)
      .where("date", "<=", endDate)
      .orderBy('date', 'asc')
      .get()
      .then(querySnapshot => resolve(snapshotToArray(querySnapshot.docs)))
  })


export const getOrders = () => new Promise((resolve, reject) => {
  firebase.app().firestore().collection('orders')
    .get()
    .then(querySnapshot => resolve(snapshotToArray(querySnapshot.docs)))
    .catch(error => reject(saveError(error, 'getOrders')))
})

// Deep clean for Firestore (remove undefined values, empty arrays and plain empty objects)
const cleanFirestoreData = (obj) => {
  if (obj === null || typeof obj !== 'object') return obj;

  // Firestore Timestamps and Dates are objects but valid — leave them as-is
  if (obj instanceof Date) return obj;
  if (obj?.constructor?.name === 'Timestamp') return obj;

  if (Array.isArray(obj)) {
    const cleaned = obj.map(cleanFirestoreData).filter(v => v !== undefined);
    // Firestore does not accept empty arrays as field values
    return cleaned.length > 0 ? cleaned : undefined;
  }

  const cleaned = {};
  Object.entries(obj).forEach(([k, v]) => {
    if (v !== undefined) {
      const cleanedValue = cleanFirestoreData(v);
      // Skip undefined results (e.g. empty arrays returned as undefined above)
      if (cleanedValue !== undefined) {
        cleaned[k] = cleanedValue;
      }
    }
  });

  // Firestore does not accept plain empty objects {} (e.g. an uninitialised date)
  // Only skip if it has no constructor (plain object) and no keys
  if (Object.keys(cleaned).length === 0 && obj.constructor === Object) return undefined;

  return cleaned;
}

export const saveOrder = order => {
  // this.db.collection('post').doc('key').set({})
  //if(producto.id) return this.editar(producto)
  return new Promise((resolve, reject) => {
    const user = getCurrentUser()
    //console.log('saveOrder')

    if (
      !order.date ||
      !moment(order.date).isValid() ||
      moment(order.date).isBefore(moment().subtract(1, 'minute')) ||
      moment(order.date).isAfter(moment().add(1, 'year'))
    ) {
      order.date = new Date()
    }

    const orderToSave = cleanFirestoreData({
      ...order,
      userEmail: user.email || ''
    })

    console.log('Admin Order to save:', orderToSave);

    firebase.app().firestore().collection('orders').add(orderToSave)
      .then(ref => resolve(ref.id))
      .catch(error => {
        // Log the failed order to evaluate it later, handling potential size limits by splitting products
        const baseOrderToSave = { ...orderToSave };
        delete baseOrderToSave.productsList;

        firebase.app().firestore().collection('failed_orders').add({
          error: error.message || error.toString(),
          date: new Date(),
          userEmail: orderToSave.userEmail || '',
          orderBase: JSON.stringify(baseOrderToSave)
        }).then(docRef => {
          if (orderToSave.productsList && Array.isArray(orderToSave.productsList)) {
            // Split productsList into individual documents to avoid 1MB limit
            const promises = orderToSave.productsList.map((prod, index) => {
              return firebase.app().firestore().collection('failed_orders').doc(docRef.id).collection('items').add({
                index,
                product: JSON.stringify(prod)
              });
            });
            return Promise.all(promises);
          }
        }).catch(e => console.error('Failed to save log for failed_orders', e));

        reject(saveError(error, 'saveOrder'))
      })
  }
  )
}

// export const updateOrder = order => new Promise((resolve, reject) => {
//   const user = getCurrentUser()
//   //console.log('updateOrder')
//   firebase.app().firestore().collection('orders').doc(order.id).update({
//     ...order,
//     userEmail: user.email || '',
//     createdAt: new Date()
//   })
//     .then(resolve('Pedido modificado'))
//     .catch(error => reject(saveError(error, 'updateOrder')))
// })

export const updateOrder = async (order) => {
  try {
    const token = await firebase.auth().currentUser.getIdToken();
    const userEmail = getCurrentUser()?.email
    console.log('updateOrder userEmail', userEmail)

    order.updatedBy = userEmail

    const response = await fetch(
      `${apiBaseUrl}/orders/order`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          orderId: order.id,
          newOrderData: order
        })
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Error al actualizar la orden');
    }

    const result = await response.json();
    console.log("Orden actualizada exitosamente:", result);
    return result;
  } catch (error) {
    console.error("Error al actualizar orden:", error);
    throw error;
  }
}

export const updateOrderState = async (order) => {
  try {
    const token = await firebase.auth().currentUser.getIdToken();
    const userEmail = await firebase.auth().currentUser?.email || '';

    console.log('updateOrderState token', token)
    console.log('updateOrderState order', order)
    const response = await fetch(
      `${apiBaseUrl}/orders/changeOrderStateByStateName`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          orderId: order.id,
          newOrderState: order.orderState,
          userEmail
        })
      }
    );
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Error al actualizar pedido');
    }
    const result = await response.json();
    console.log("Pedido actualizado exitosamente:", result);
    return result;
  } catch (error) {
    console.error("Error al actualizar orden:", error);
    throw error;
  }
}


export const getOrderById = id => new Promise((resolve, reject) => {
  firebase.app().firestore().collection('orders').doc(id).get()
    .then(doc => {
      !doc.exists && resolve({})
      resolve({ ...doc.data(), id })
    })
    .catch(error => reject(saveError(error, 'getOrderById')))
})

export const deleteOrder = (orderId) => new Promise((resolve, reject) => {
  firebase.app().firestore().collection('orders').doc(orderId).delete()
    .then(resolve('Pedido borrado'))
    .catch(error => reject(saveError(error, 'deleteOrder')))
})


export const saveOrderHistory = history => new Promise((resolve, reject) => {
  firebase.app().firestore().collection('orders').doc(history.orderId).collection('history').add({
    ...history,
    date: new Date(),
  })
    .then(ref => resolve(ref.id))
    .catch(error => reject(saveError(error, 'saveOrderHistory')))
}
)

export const getOrderHistory = orderId => new Promise((resolve, reject) =>
  firebase.app().firestore().collection('orders').doc(orderId).collection('history')
    .orderBy('date', 'asc')
    .get()
    .then(querySnapshot => resolve(snapshotToArray(querySnapshot.docs)))
    .catch(error => reject(saveError(error, 'getOrderHistory')))
)

















